<script setup lang="ts">
import BrandBar from "@/components/identity/BrandBar.vue";
import NavigationButton from "./NavigationButton.vue";
</script>

<template>
    <nav class="bg-white/50 flex gap-4 h-[46px]">
        <BrandBar />
        <div class="flex h-full ml-8">
            <NavigationButton to="/"> Home </NavigationButton>
            <NavigationButton to="/about"> About </NavigationButton>
            <NavigationButton to="/contact"> Contact </NavigationButton>
        </div>
    </nav>
</template>
